interface NowMarkerProps {
  /** Vertical position within the scroll content, in pixels. */
  offset: number
  label: string
  style: 'classic' | 'modern'
}

/**
 * The current-time indicator.
 *
 * Positioned with `transform: translateY` rather than `top`, so moving it each
 * minute is a compositor operation and never triggers layout on a list of tens
 * of thousands of rows.
 */
export function NowMarker({ offset, label, style }: NowMarkerProps) {
  return (
    <div
      className={`tl-now tl-now--${style}`}
      style={{ transform: `translateY(${offset}px)` }}
      aria-hidden="true"
    >
      {style === 'classic' ? (
        <span className="tl-now-triangle" />
      ) : (
        <span className="tl-now-time">{label}</span>
      )}
      <span className="tl-now-line" />
    </div>
  )
}
